import authenticatedHttpClientFactory from '@/modules/core/services/authenticatedHttpClientFactory';

export const getVisionFiveCharts = async(options) => {
  const params = {
    dataInicial: options.initialDate,
    dataFinal: options.endDate,
    status: options.status,
    usuariosIds: options.users || '',
  };
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(
    `dashboard/graficoRankingProdutos?${new URLSearchParams(params).toString()}`,
  );
  const total = response.data.reduce((total, value) => total + value.valor, 0);
  const x = response.data.map((value) => value.valor);
  const y = response.data.map((value) => value.nome);
  return { total, x, y };
};
